module.exports = __webpack_public_path__ + "img/zynl.43cb841d.png";